/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Service, { service } from '@ember/service';
import { computed } from '@ember/object';

const jurisdictionMapping = {
  1: 'nz',
  4: 'nsw',
};

const urls = [
  // Admin kits
  {
    id: 'attendance',
    url: 'https://info.our-hero.com/app/admin-kit',
    includeJurisdiction: true,
  },
  {
    id: 'medications',
    url: 'https://info.our-hero.com/app/admin-kit',
    includeJurisdiction: true,
  },
  {
    id: 'locations',
    url: 'https://info.our-hero.com/app/admin-kit',
    includeJurisdiction: true,
  },
  {
    id: 'groups',
    url: 'https://info.our-hero.com/app/admin-kit',
    includeJurisdiction: true,
  },
  {
    id: 'fields',
    url: 'https://info.our-hero.com/app/admin-kit',
    includeJurisdiction: true,
  },
  {
    id: 'sickbay',
    url: 'https://info.our-hero.com/app/admin-kit',
    includeJurisdiction: true,
  },
  {
    id: 'wellbeing',
    url: 'https://info.our-hero.com/app/admin-kit',
    includeJurisdiction: true,
  },
  {
    id: 'finance',
    url: 'https://info.our-hero.com/app/finance-kit',
    includeJurisdiction: true,
  },
  // Premier
  {
    id: 'bookings',
    url: 'https://info.our-hero.com/app/comms-kit',
    includeJurisdiction: true,
  },
  // Power Ups
  {
    id: 'pages',
    url: 'https://info.our-hero.com/app/pages',
    includeJurisdiction: false,
  },
  {
    id: 'goals',
    url: 'https://info.our-hero.com/app/goals',
    includeJurisdiction: false,
  },
  {
    id: 'milestones',
    url: 'https://info.our-hero.com/app/milestones',
    includeJurisdiction: false,
  },
  {
    id: 'reporting',
    url: 'https://info.our-hero.com/app/reporting',
    includeJurisdiction: false,
  },
  // Resourcing
  {
    id: 'guides',
    url: 'https://info.our-hero.com/app/hero-guides',
    includeJurisdiction: true,
  },
  {
    id: 'resources',
    url: 'https://info.our-hero.com/app/resources',
    includeJurisdiction: true,
  },
  {
    id: 'engage',
    url: 'https://info.our-hero.com/app/bookings',
    includeJurisdiction: true,
  },
  {
    id: 'reporting-updates',
    url: 'https://info.our-hero.com/app/reporting-updates',
    includeJurisdiction: false,
  },
];

export default class HubspotLinksService extends Service {
  @service
  session;

  @computed('session.school.jurisdiction')
  get modifiedURLs() {
    let jurisdiction = this.get('session.school.jurisdiction');
    let jurisdictionKey = jurisdictionMapping[jurisdiction] || 'intl';

    return urls.map(({ id, url, includeJurisdiction }) => {
      let modifiedUrl = includeJurisdiction ? `${url}/${jurisdictionKey}` : url;
      return {
        id: id,
        url: modifiedUrl,
      };
    });
  }
}
